import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_SEO = "getlist";
export const SET_LIST_SEO = "setSeo";



const state = {
    seos: [],
};

const getters = {
    seos(state) {
        return state.seos;
    },
};

const actions = {
    [GET_LIST_SEO](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.GET_LIST_SEO}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
};

const mutations = {
    [SET_LIST_SEO](state, data) {
        state.seos = data.data;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};